import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PaymentInfoCustomer from './PaymentInfoCustomer'
import InvoiceCredited from './InvoiceCredited'
import InvoiceAlreadyPaid from './InvoiceAlreadyPaid'
import InvoiceFinalInvoice from './InvoiceFinalInvoice'
import OneClickPaymentApi from '../services/api/OneClickPayment'
import PaymentSuccess from './PaymentSuccess'
import OneClickPaymentText from './OneClickPaymentText'
import Context from '../context/Context'
import { InvoiceTypes, PaymentTypes, InvoiceStatuses } from '../helpers/Constants'

const OneClickAlreadyPaid = ({ paymentApprovalTypeId, loaded }) => {
  return (
    <div>
      <PaymentSuccess />
      <div className="row">
        <div className="col-12 text-center mt-3">
          {(loaded)
            ? <OneClickPaymentText paymentApprovalTypeId={paymentApprovalTypeId} />
            : null
          }
        </div>
      </div>
    </div>
  )
}

const InvoiceStatus = () => {
  const context = useContext(Context)
  const [oneClickInfo, setOneClickInfo] = useState({})
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (parseInt(context.invoice.current_payment_type_id) === PaymentTypes.ONE_CLICK) {
      const oneClickPaymentApi = new OneClickPaymentApi()
      oneClickPaymentApi.get(context.invoice.ocr)
        .then(res => res.json())
        .then(data => {
          setOneClickInfo(data)
          setLoaded(true)
        })
        .catch(error => {
          console.error(error.message)
        })
    }
  }, [context.invoice.current_payment_type_id, context.invoice.ocr])

  if (parseInt(context.invoice.invoice_status_id) === InvoiceStatuses.CREDITED) {
    return (
      <div>
        <PaymentInfoCustomer />
        <InvoiceCredited />
      </div>
    )
  }

  if (parseInt(context.invoice.invoice_status_id) === InvoiceStatuses.FULLY_PAID) {
    return (
      <div>
        <PaymentInfoCustomer />
        <InvoiceAlreadyPaid />
      </div>
    )
  }

  if (parseInt(context.invoice.invoice_type_id) === InvoiceTypes.FINAL) {
    return (
      <div>
        <PaymentInfoCustomer />
        <InvoiceFinalInvoice />
      </div>
    )
  }

  if (parseInt(context.invoice.current_payment_type_id) === PaymentTypes.ONE_CLICK) {
    return (
      <div>
        <OneClickAlreadyPaid
          paymentApprovalTypeId={oneClickInfo.payment_approval_type_id}
          loaded={loaded} />
      </div>
    )
  }

  return null
}

OneClickAlreadyPaid.propTypes = {
  paymentApprovalTypeId: PropTypes.string,
  loaded: PropTypes.bool.isRequired
}

export default InvoiceStatus
